/* eslint-disable @typescript-eslint/no-unsafe-call */
import { clearNoExpectedNodeInPrerender, dispatchRenderEventOnPreloadScript } from '@hb/coffee-prerender';

/** 当前route页面是否为平台的html预渲染 */
let currentRouteIsFirstRender = true;

window.addEventListener('hashchange', () => {
  currentRouteIsFirstRender = false;
});

/**
 * 当前html页面是否为当前route预渲染的运行状态
 * 如下情况为true：首次进入页面pr_home_v2_verify-credit.html#/v2/verify-credit
 * 若切换router后，也返回false
 */
export const currentIsPrerenderRunning = (): boolean => {
  if (currentRouteIsFirstRender) {
    const matchRegExp = /pr_home_v2_([^.]+).html#\/v2\/([^?#/]+)/;
    const matchRes = matchRegExp.exec(window.location.href);

    if (matchRes && matchRes[1] && matchRes[2]) {
      return matchRes[1] === matchRes[2];
    }
  }

  return false;
};

/**
 * 页面生成预渲染-mounted生命周期通用方法
 * 此方法包含如下定制化处理：
 *  1).script脚本改成preload
 *  2).svg雪碧图产物清理
 *  3).axios.min.js脚本删除
 */
export const commonDispatchPreRender = (): void => {
  dispatchRenderEventOnPreloadScript();
  /** 预渲染模式，清空svg雪碧图产物 */
  clearNoExpectedNodeInPrerender('#__SVG_SPRITE_NODE__');
  /** 预渲染模式，删除axios.min.js脚本标签 */
  clearNoExpectedNodeInPrerender('script[src*="axios.min.js');
  /** 预渲染产物，先删除天启相关script，运行时再动态插入 */
  clearNoExpectedNodeInPrerender('script[id=tianQiUbtBundle');
  clearNoExpectedNodeInPrerender('script[id=tianQiApmBundle');
};
